import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Full-size image viewer (modal-xl). Safe to nest above other modals (z-index 1100).
 */
const ImagePreviewModal = ({ show, onClose, src, title }) => {
  const { t } = useTranslation();

  if (!show || !src) return null;

  return (
    <div
      className="modal d-block"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.75)", zIndex: 1100 }}
      tabIndex="-1"
      role="dialog"
      onClick={onClose}
    >
      <div
        className="modal-dialog modal-xl modal-dialog-centered"
        role="document"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <div className="modal-header py-2">
            <h5 className="modal-title mb-0">{title || t("Image Preview")}</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close" />
          </div>
          <div
            className="modal-body text-center p-3"
            style={{ maxHeight: "85vh", overflow: "auto" }}
          >
            <img
              src={src}
              alt={title || t("Image Preview")}
              style={{
                maxWidth: "100%",
                maxHeight: "75vh",
                width: "auto",
                height: "auto",
                objectFit: "contain",
                borderRadius: 8,
              }}
            />
          </div>
          <div className="modal-footer py-2">
            <button type="button" className="btn btn-light" onClick={onClose}>
              {t("Close")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImagePreviewModal;
